import { Card, Typography, useTheme } from '@mui/material';

interface PoolsOverviewPropsType {
  title: string;
  content: string;
}

const PoolsOverview = ({ title, content }: PoolsOverviewPropsType) => {
  // theme
  const theme = useTheme();

  return (
    <Card
      sx={{
        flex: 1,
        padding: '10.37px 16px',
        borderRadius: '10px',
        border: `0.5px solid ${theme.greyscale.lightgrey1}`,
        boxShadow: '0px 0px 4px 0px #00000026',
      }}
    >
      <Typography variant="body1" color={theme.greyscale.grey1}>
        {title}
      </Typography>
      <Typography align="right" variant="h4" color={theme.greyscale.darkgrey2}>
        {content}
      </Typography>
    </Card>
  );
};

export default PoolsOverview;
